import { createSelector } from 'reselect';

import { FEATURE_FLAGS_FROM_STATE, FeatureFlagNamesType } from 'yeself-common/typings/FeatureFlags';

const getFeatures = (state: {
    featureFlags: typeof FEATURE_FLAGS_FROM_STATE;
}): typeof FEATURE_FLAGS_FROM_STATE => state.featureFlags;

const getFeatureFlagByName = (
    state: { featureFlags: typeof FEATURE_FLAGS_FROM_STATE },
    name: FeatureFlagNamesType
): boolean | undefined => state.featureFlags[name];

export const selectFeatureFlags = createSelector([getFeatures], (flags) => flags);

export const makeSelectFeatureIsEnabled = () =>
    createSelector([getFeatureFlagByName], (flag) => flag || false);
